import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { UserLoginResponse } from '@utils/types/resellers/user-login.ts';
import { AxiosError } from 'axios';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';

export const useGetResellerUserLogin = (customerId: string) => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;
  const sort = (searchParams.sort as string | undefined) || undefined;
  const direction =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;
  const q = (searchParams.q as string | undefined) || undefined;

  const fetchLogins = async () => {
    if (!customerId) throw new Error('customerId is required');
    const { resellerCustomersByCustomerId } = GET_URL_NEW();
    const url = resellerCustomersByCustomerId(customerId, {
      offset,
      limit,
      q,
      sort,
      direction
    });
    const { data } = await Axios.get<UserLoginResponse>(url);
    return data;
  };

  return useQuery<UserLoginResponse, AxiosError<BaseError>>(
    ['resellerCustomerLogin', customerId, offset, limit, q, sort, direction],
    fetchLogins,
    { enabled: !!customerId, keepPreviousData: true }
  );
};
